// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"715":"list","962":"home"}[chunkId] || chunkId) + "." + {"382":"fdf1e1ca","570":"62940b08","715":"fadf9ed0","962":"89d32baf"}[chunkId] + ".js";
};